import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, LockIcon } from 'lucide-react';
const stats = [{
  label: 'Funding Speed',
  value: '24–48 Hours'
}, {
  label: 'Funding Solutions',
  value: 'Multiple Options'
}, {
  label: 'No Credit Impact',
  value: 'No Hard Pull'
}];
const testimonials = [{
  quote: 'Cotifunding got me $75K in 2 days when my bank said no. Game changer for my construction business.',
  name: 'Marcus T.',
  business: 'Construction',
  rating: 5
}, {
  quote: 'The process was incredibly simple. Applied on Monday, had funds by Wednesday.',
  name: 'Sarah L.',
  business: 'Restaurant Owner',
  rating: 5
}, {
  quote: 'No hard credit pull was huge for me. Got matched with the perfect funding option.',
  name: 'James R.',
  business: 'Trucking Company',
  rating: 5
}];
export function SocialProof() {
  return <section className="py-12 px-4 bg-charcoal" data-id="element-125">
      <div className="max-w-7xl mx-auto" data-id="element-126">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="flex flex-col md:flex-row justify-around items-center gap-8 mb-12 pb-12 border-b border-gray-800" data-id="element-127">
          {stats.map((stat, index) => <div key={stat.label} className="text-center" data-id="element-128">
              <div className="text-5xl md:text-6xl font-bold text-gold-primary mb-2" data-id="element-129">
                {stat.value}
              </div>
              <div className="text-gray-400 font-medium" data-id="element-130">{stat.label}</div>
            </div>)}
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8 mb-12" data-id="element-131">
          {testimonials.map((testimonial, index) => <motion.div key={testimonial.name} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="bg-black border border-gray-800 rounded-xl p-6" data-id="element-132">
              <div className="flex gap-1 mb-4" data-id="element-133">
                {[...Array(testimonial.rating)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-gold-primary text-gold-primary" data-id="element-134" />)}
              </div>
              <p className="text-gray-300 mb-6 leading-relaxed" data-id="element-135">
                "{testimonial.quote}"
              </p>
              <div data-id="element-136">
                <div className="font-bold" data-id="element-137">{testimonial.name}</div>
                <div className="text-sm text-gray-400" data-id="element-138">
                  {testimonial.business}
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="flex items-center justify-center gap-2 text-gray-400" data-id="element-139">
          <LockIcon className="w-5 h-5 text-gold-primary" data-id="element-140" />
          <span data-id="element-141">Your information is secure and encrypted</span>
        </motion.div>
      </div>
    </section>;
}